document.addEventListener('DOMContentLoaded', () => {
  const payButton = document.getElementById('pay-with-stripe');

  if (!payButton) return;

  const stripePublicKey = document.querySelector('meta[name="stripe-publishable-key"]')?.content;
  if (!stripePublicKey) {
    console.error('Stripe publishable key not found.');
    return;
  }

  const stripe = Stripe(stripePublicKey);

  payButton.addEventListener('click', async (e) => {
    e.preventDefault();

    const arrival = document.getElementById('arrival_date')?.value;
    console.log("Arrival date: ", arrival)
    const departure = document.getElementById('departure_date')?.value;
    const guests = document.getElementById('number_of_guests')?.value;
    const price = document.getElementById('booking_price')?.value;

    if (!arrival || !departure || !guests || !price) {
      alert("Missing booking details.");
      return;
    }

    try {
      const response = await fetch('/api/payments/checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({
          payment: {
            arrival_date: arrival,
            departure_date: departure,
            number_of_guests: guests,
            booking_price: price
          }
        })
      });

      const data = await response.json();

      if (data.id) {
        stripe.redirectToCheckout({ sessionId: data.id });
      } else {
        alert('Failed to start payment session.');
        console.error(data);
      }

    } catch (err) {
      console.error("Payment error:", err);
      alert("An error occurred. Please try again.");
    }
  });
});
